export default __webpack_public_path__ + "static/media/woo2.21a4a8be.png";